<template>
  <!-- Figma: 112x140 / rounded-[2px] / overflow-clip。サムネ・タイトルは共通コンポーネントで描画する -->
  <NuxtLink class="group relative block h-[140px] w-[112px] shrink-0 overflow-clip rounded-[2px]" :to="detailPageLink" @click="props.onClick">
    <FeaturedThumbnailImage :alt="featured.titleEn" :src="imageUrl" />
    <FeaturedThumbnailTitle>{{ featured.titleEn }}</FeaturedThumbnailTitle>
  </NuxtLink>
</template>

<script setup lang="ts">
import FeaturedThumbnailImage from '@/wabunka-src/common/features/Featured/components/FeaturedThumbnailImage/FeaturedThumbnailImage.vue';
import FeaturedThumbnailTitle from '@/wabunka-src/common/features/Featured/components/FeaturedThumbnailImage/FeaturedThumbnailTitle.vue';
import { generateDetailPageLink, getBackgroundImageUrl, type MinimumFeaturedViewModel } from '@/wabunka-src/common/features/Featured/models/minimunFeatured/minimumFeatured';

interface Props {
  featured: MinimumFeaturedViewModel;
  onClick?: () => void;
}

const props = defineProps<Props>();

const imageUrl = computed(() => getBackgroundImageUrl(props.featured));
const detailPageLink = computed(() => generateDetailPageLink(props.featured));
</script>
